import React from "react";

import { css } from "@emotion/core";
import { useContext } from "react";
import { useApolloInjection } from "@zapier/checkout/esm/contexts/ApolloInjection";
import { Currency, CurrencyContext, Price } from "@zapier/currency";

import {
  Colors,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableTd,
  TableTh,
  useTheme,
} from "@zapier/design-system";

import { PlanTier } from "@zapier/checkout/esm/types";

import { useCurrentPlanTiers } from "./hooks/useCurrentPlanTiers";

type MeteredTiersTableProps = {
  /**
   * If not provided, component will retrieve tiers from the user's current plan.
   **/
  tiers?: PlanTier[];
};

const formatTier = (numTasks: number, tierIndex: number) =>
  numTasks === -1
    ? "Any Additional"
    : `${tierIndex === 0 ? "First" : "Next"} ${numTasks.toLocaleString(
        "en-US"
      )}`;

const formatPrice = (price: number, currency: Currency) =>
  price === 0 ? (
    "Included"
  ) : (
    <Price currency={currency} maxDecimals={4}>
      {price}
    </Price>
  );

const cell = css`
  background-color: transparent !important;
  font-size: 14px;
  padding: 0.5em 1em !important;
`;

const td = css`
  color: #9e96a2;
`;

const rebrandTd = css`
  color: ${Colors.neutral800};
`;

const formatTiers = (
  data: PlanTier[] = [],
  currency: Currency,
  isRebrand: boolean
) => {
  return data.map((tier, i) => (
    <TableRow key={i}>
      {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
      <TableTd className={[cell, td, isRebrand && rebrandTd]}>
        {formatTier(tier.numTasks, i)}
      </TableTd>
      {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
      <TableTd className={[cell, td, isRebrand && rebrandTd]}>
        {formatPrice(tier.pricePerTask, currency)}
      </TableTd>
    </TableRow>
  ));
};

export const MeteredTiersTable = ({ tiers }: MeteredTiersTableProps) => {
  const { isRebrand } = useTheme();
  const currency = useContext(CurrencyContext);
  const { useQuery } = useApolloInjection();
  const { currentPlanTiers } = useCurrentPlanTiers({ skip: !!tiers, useQuery });
  const planTiers = tiers ?? currentPlanTiers ?? [];

  const rows = formatTiers(planTiers, currency, isRebrand);

  return planTiers.length > 0 ? (
    <Table kind="standard">
      <TableHead>
        <TableRow>
          {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
          <TableTh className={cell}>Tasks</TableTh>
          {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
          <TableTh className={cell}>Price Per Task</TableTh>
        </TableRow>
      </TableHead>
      <TableBody>{rows}</TableBody>
    </Table>
  ) : null;
};
